import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import { useAddonStyles, useSubtleIcon } from 'kineticUtils/styles';

const usePreferencesMenuStyles = makeStyles(({ palette, spacing }) => {
  const { addons } = useAddonStyles(spacing);
  const { subtleIcon } = useSubtleIcon(palette);
  return createStyles({
    addons,
    subtleIcon,
    icon: {
      marginRight: spacing(),
    },
    menuItem: {
      width: 260,
    },
    editingMenuItem: {
      overflow: 'visible',
      // cant override focusVisible class, force no bg color when editing
      backgroundColor: 'transparent !important',
    },
    editableWrapper: {
      maxWidth: 230,
    },
    menuItemsWrapper: {
      padding: `${spacing(1.5)} 0`,
    },
    button: {
      fontSize: 'inherit',
      borderRadius: 0,
      '&:hover': {
        backgroundColor: palette.primary.light,
      },
    },
    contextMenu: {
      padding: 0,
    },
    defaultIcon: {
      marginLeft: spacing(2),
    },
  });
});

export default usePreferencesMenuStyles;
